export const entrezConfig = {
  PageSize: 20,
  PagesSizeOptions:[5, 10, 20, 50, 100, 200],
  Operators: ["AND", "OR", "NOT"],
  FieldAsNone: "All",
  DefaultDB:"pubmed",
  SearchHistoryCount:100,
  NCBIDefaultLInk:"https://www.ncbi.nlm.nih.gov",
  NCBLinks:{"Pccompound":"https://pubchem.ncbi.nlm.nih.gov/compound/",

    // DB as key : link as value   --- note db name should be exactly as shown in selection list
    // "Pubmed":"https://www.ncbi.nlm.nih.gov",
    
  },
PublicationDateEligibleDbs: ['pubmed', 'pmc'],

ExcludeColumns:['authtype'],
};

